var map = {
	"./1/Gabinet-Doświetlony gabinet z miejscem na biurko.jpg": 6452,
	"./1/Kuchnia z wyspą-Kuchnia z oknem oraz wyspą po środku.jpg": 3928,
	"./1/Salon-Przestronny salon z kanapą i biblioteczką.jpg": 3941,
	"./1/Łazienka-Urokliwa łazienka w stylu minimalistycznym.jpg": 5553,
	"./2/Pułaskiego 32-Widok od strony bramy.jpg": 1922,
	"./2/Pułaskiego 32-Widok od strony ogródka.jpg": 2412,
	"./2/Pułaskiego 32-Widok od strony wejścia.jpg": 7871,
	"./2/Pułaskiego 32-Widok z przodu.jpg": 8829,
	"./3/Sadowa 20-Teren zielony.jpg": 8262,
	"./3/Sadowa 20-Widok od strony bramy.jpg": 931,
	"./3/Sadowa 20-Widok od strony ogródka.jpg": 3309,
	"./3/Sadowa 20-Widok od strony wejścia.jpg": 6318,
	"./4/Domy szkieletowe OMD-Dom w godzinach porannych.jpg": 369,
	"./4/Domy szkieletowe OMD-Dom w godzinach wieczornych.jpg": 8970,
	"./4/Domy szkieletowe OMD-Widok od frontu.jpg": 5278,
	"./4/Domy szkieletowe OMD-Widok od strony ogródka.jpg": 3594,
	"./5/Dobranowice-Dom w godzinach wieczornych.jpg": 4521,
	"./5/Dobranowice-Rzut z lotu ptaka.jpg": 5482,
	"./5/Dobranowice-Widok od frontu.jpg": 2589,
	"./5/Dobranowice-Widok od strony ogródka.jpg": 9849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4335;